<template>
  <div id="app">
    <div class="bottom-container">
      <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank" class="text_color">粤ICP备2024274051号</a>
      <img src="@/assets/images/web_police.png" class="second_part_icon" alt="">
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002004059" rel="noreferrer" target="_blank"
         class="text_color">粤公网安备44030002004059</a>
    </div>
    <div style="margin-bottom: 30px">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>

.content-container {
  width: 100%;
  min-height: 100%;
  height: 100%;

  display: flex;
  flex-direction: column-reverse;
}


.routine-container {
  width: 100%;
  height: 300px;

  background-color: red;
}

.bottom-container {
  position: fixed;
  //left: 0;
  //right: 0;
  bottom: 10px;
  left: 0;
  right: 0;
  //top: calc(100% - 50px);

  //background-color: red;

  //width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  //width: 100%;

  align-items: center;
  align-content: center;

  justify-content: center;
  justify-items: center;

  text-align: center;

  z-index: 10;

  //border-top: 10px solid #409EFF;
}

.main-body {
  width: 100%;
  height: calc(100% - 10000px);
}

.second_part_icon {
  margin-left: 10px;
  width: 16px;
  height: 16px;
}

.text_color {
  color: grey;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue